import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { TContentHubHeroBannerFields, TContentHubHeroBannerProps } from '../types/productHeroBanner.types';
import { TContentHubButton, TRendition } from '../../../types/types';
import { appendRootToRichTextInternalLinks } from '../../../utils/appendRootToRichTextInternalLinks.utils';
import { appendRootToInternalLink } from '../../../utils/appendRootToInternalLink.utils';

export class ProductHeroBannerModel {
  private readonly fields?: TContentHubHeroBannerFields;
  private readonly params?: ComponentParamsGeneral;
  private readonly rendering?: ComponentRendering;

  constructor(props: TContentHubHeroBannerProps) {
    this.fields = props?.fields;
    this.params = props?.params;
    this.rendering = props?.rendering;
  }

  get thumbnailEE(): string {
    return this.fields?.itemData?.thumbnail || '';
  }

  get componentName(): string {
    return this.rendering?.componentName || '';
  }

  get textColor(): string {
    return this.params?.textColor;
  }

  get title(): string | undefined {
    return this.fields?.apiData?.title;
  }

  get description(): string | undefined {
    return appendRootToRichTextInternalLinks(this.fields?.apiData?.description);
  }

  get eyebrow(): string | undefined {
    return this.fields?.apiData?.eyebrow;
  }

  get desktopImage(): TRendition | undefined {
    return this.fields?.apiData?.assets?.[0]?.rendition_desktop_size1900;
  }

  get desktopSDImage(): TRendition | undefined {
    return this.fields?.apiData?.assets?.[0]?.rendition_desktop_size1300;
  }

  get tabletImage(): TRendition | undefined {
    return this.fields?.apiData?.assets?.[0]?.rendition_tablet_size1300;
  }

  get tabletLandscapeImage(): TRendition | undefined {
    return this.fields?.apiData?.assets?.[0]?.rendition_tablet_size1000;
  }

  get mobileImage(): TRendition | undefined {
    return this.fields?.apiData?.assets?.[0]?.rendition_mobile_size1100;
  }

  get primaryLink(): TContentHubButton | undefined {
    return this.fields?.apiData?.button1;
  }

  get primaryLinkUrl(): string | undefined {
    return appendRootToInternalLink(this.primaryLink?.url);
  }

  get secondaryLink(): TContentHubButton | undefined {
    return this.fields?.apiData?.button2;
  }

  get secondaryLinkUrl(): string | undefined {
    return appendRootToInternalLink(this.secondaryLink?.url);
  }

  get labelCost(): string | undefined {
    return this.fields?.apiData?.optionalLabel1;
  }

  get price(): string | undefined {
    return this.fields?.apiData?.msrp;
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }

  get isGradientDisabled(): boolean | undefined {
    return this.params?.disableGradient === '1';
  }

  get enableBuildPriceCTA(): boolean | undefined {
    return this.params?.enableBuildPriceCTA === '1';
  }
}
